export default __webpack_public_path__ + "static/media/28.82527f18.jpg";